import { Head, useForm, usePage } from "@inertiajs/react"
import { useState } from "react"

import HeadingSmall from "@/components/heading-small"
import UserForm from "@/components/users/user-form"
import AppLayout from "@/layouts/app-layout"
import SettingsLayout from "@/layouts/settings/layout"
import { settingsProfilePath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Profile settings",
    href: settingsProfilePath(),
  },
]

export default function Profile() {
  const { auth } = usePage().props
  const [preview, setPreview] = useState<string | null>(null)
  const user = auth.user
  const { data, setData, patch, processing, errors, recentlySuccessful } =
    useForm({
      user: {
        name: user.name,
        avatar: null as File | null,
      },
    })

  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files[0]) {
      setData("user", { ...data.user, avatar: e.target.files[0] })
      setPreview(URL.createObjectURL(e.target.files[0]))
    }
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    patch(settingsProfilePath(), {
      forceFormData: true,
      // onSuccess: () => {
      //   toast.success('Profile updated successfully');
      // }
    })
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={breadcrumbs[breadcrumbs.length - 1].title} />

      <SettingsLayout>
        <div className="space-y-6">
          <HeadingSmall
            title="Profile"
            description="How you appear in this workspace."
          />

          <UserForm
            user={user}
            onSubmit={handleSubmit}
            data={data}
            setData={setData}
            processing={processing}
            errors={errors}
            recentlySuccessful={recentlySuccessful}
            preview={preview}
            onFileChange={handleFileChange}
          />
        </div>
      </SettingsLayout>
    </AppLayout>
  )
}
